import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

import { getEnrollmeOrigin } from 'helpers/getImpersonateUrl'
import {
  ENVIROMENT_DEMO,
  ENVIROMENT_DEV,
  ENVIROMENT_PROD,
  ENVIROMENT_QA,
  ENVIROMENT_TEST,
  getEnvironment,
  isLocal,
  isStg,
} from 'modules/app-config/environment'

import {
  RecruitingInvitationStatusEnum,
  type RecruitingInvitation,
} from '../schema/recruiting.schema'

const ENROLLME_ORIGIN_BY_ENV = {
  dev: 'https://enrollme.dev.surecolabs.com',
  stg: 'https://enrollme.stg.surecolabs.com',
  prod: 'https://enrollme.sureco.com',
} as const

dayjs.extend(utc)

export function getInvitationStatus(
  invitation: Pick<RecruitingInvitation, 'cancelledAt' | 'expiresAt'>,
  now: dayjs.Dayjs = dayjs()
): RecruitingInvitationStatusEnum {
  if (invitation.cancelledAt) {
    return RecruitingInvitationStatusEnum.Cancelled
  }

  if (dayjs(invitation.expiresAt).isBefore(now)) {
    return RecruitingInvitationStatusEnum.Expired
  }

  return RecruitingInvitationStatusEnum.Active
}

/** Label for the Expiry Days column; API `expiresAt` is always end-of-day. */
export function formatInvitationExpiryDays(
  expiresAt: string | undefined,
  status: RecruitingInvitationStatusEnum,
  now: dayjs.Dayjs = dayjs()
): string | null {
  if (status === RecruitingInvitationStatusEnum.Expired) {
    return 'Expired'
  }

  const expires = dayjs(expiresAt)
  if (!expires.isValid()) {
    return null
  }

  if (expires.isBefore(now)) {
    return 'Expired'
  }

  const daysUntil = expires.utc().diff(now.utc(), 'day')
  if (daysUntil === 0) {
    return 'Today'
  }

  return `${daysUntil} days`
}

export function getRecruitingEnrollmeOrigin(): string {
  if (isLocal()) {
    return ENROLLME_ORIGIN_BY_ENV.dev
  }

  if (isStg()) {
    return ENROLLME_ORIGIN_BY_ENV.stg
  }

  const environment = getEnvironment()
  if (
    environment === ENVIROMENT_DEV ||
    environment === ENVIROMENT_TEST ||
    environment === ENVIROMENT_QA
  ) {
    return ENROLLME_ORIGIN_BY_ENV.dev
  }

  if (environment === ENVIROMENT_PROD || environment === ENVIROMENT_DEMO) {
    return ENROLLME_ORIGIN_BY_ENV.prod
  }

  return getEnrollmeOrigin()
}

export function getRecruitingInvitationUrl(id: string): string {
  return `${getRecruitingEnrollmeOrigin()}/recruiting/${id}`
}
